var map = {
	"./ameca-logo.jpeg": 2074,
	"./bg-tile.jpg": 4974,
	"./contact.png": 9889,
	"./faras-logo.jpeg": 8080,
	"./faras1.png": 6654,
	"./faras2.png": 6206,
	"./faras3.png": 1623,
	"./faras4.png": 6158,
	"./faras5.png": 8691,
	"./faras6.png": 9875,
	"./faras7.png": 258,
	"./faras8.png": 9361,
	"./fatima-photo.jpeg": 9640,
	"./frontier-logo.png": 4785,
	"./frontier-ls1.jpeg": 3238,
	"./frontier-ls2.jpeg": 4991,
	"./frontier-ls3.jpeg": 6123,
	"./frontier-ls4.jpeg": 5547,
	"./frontier-ls5.jpeg": 5958,
	"./frontier-ls6.jpeg": 8661,
	"./frontier-ls7.jpeg": 8012,
	"./frontier-ls8.jpeg": 3417,
	"./frontier-ls9.jpeg": 1760,
	"./frontier1.jpeg": 3896,
	"./frontier2.jpeg": 170,
	"./frontier3.jpeg": 2865,
	"./frontier4.jpeg": 2658,
	"./frontier5.jpeg": 5200,
	"./moon-phase.png": 5817,
	"./next.png": 1828,
	"./prev.png": 4104,
	"./robot-thumbnail.png": 8001,
	"./robot.jpeg": 384,
	"./robot2.jpeg": 8998,
	"./space-noob-thumbnail.jpg": 5451,
	"./space-noob1.png": 275,
	"./space-noob2.png": 4912,
	"./space-noob3.png": 8587,
	"./space-noob4.png": 3876,
	"./space-noob5.png": 6690,
	"./space-noob6.png": 2933,
	"./space-noob7.png": 7709,
	"./space-noob8.png": 1675
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1327;